import {Component, inject, Input} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import { MatDialog } from '@angular/material/dialog';
import {CopilotCreativeModalComponent} from '../copilot-creative-modal/copilot-creative-modal.component';


@Component({
  selector: 'app-copilot-creatives-message',
    imports: [
        NgForOf,
        NgIf
    ],
  templateUrl: './copilot-creatives-message.component.html',
  styleUrl: './copilot-creatives-message.component.scss'
})
export class CopilotCreativesMessageComponent {
  @Input() creativesURLs: string[] | undefined;
  private dialog = inject(MatDialog);

  public openCreative(url: string): void {
    if (!url) {
      return;
    }
    this.dialog.open(CopilotCreativeModalComponent, {
      data: { imgUrl: url },
    });
  }
}
